import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { IconName } from '../../../../../components/Atoms/Icon/Icon.enum';
import Link from '../../../../../components/Atoms/Link/Link';
import { TextSizeType } from '../../../../../shared/styling/BaseText/BaseText.enum';
import sendGTMEvent from '../../../../common/analytics/sendGTMEvent';
import { clearRecentSearches } from '../../utils';
import { AutocompleteItem } from '../AutocompleteItem/AutocompleteItem';
import { RecentlySearchedHeader, RecentlySearchedHeaderText, StyledRecentlySearched, } from './RecentlySearched.styled';
export const RecentlySearched = ({ setPhrase, setIsOpen, handleClick, recentlySearched, setRecentlySearched, phrase, }) => {
    const [activeIndex, setActiveIndex] = useState(-1);
    const handleSelect = useCallback(({ index, recentlySearchedItem, }) => {
        const { phrase: recentlySearchedPhrase, categories } = recentlySearchedItem;
        const hasCategoryParam = !!(categories === null || categories === void 0 ? void 0 : categories.filter(Boolean).length);
        const queryParams = hasCategoryParam ? { category: categories[0] } : undefined;
        setPhrase(recentlySearchedPhrase);
        sendGTMEvent({
            event: 'search_perform',
            search_term: recentlySearchedPhrase && recentlySearchedPhrase.toLowerCase(),
            search_input: phrase ? phrase.toLowerCase() : '(empty_input)',
            search_method: `history|${(queryParams === null || queryParams === void 0 ? void 0 : queryParams.category) ? 'category' : 'regular'}`,
            search_category: (queryParams === null || queryParams === void 0 ? void 0 : queryParams.category) || '',
        });
        handleClick &&
            handleClick({
                searchPhrase: phrase,
                params: queryParams,
                category: hasCategoryParam ? categories[0] : '',
                listingFunction: 'recently_searched',
                listingType: 'autocomplete',
                phrase: recentlySearchedPhrase,
                searchPosition: index,
            });
    }, [handleClick, setPhrase, phrase]);
    const handleKeyboardEvents = useCallback((event) => {
        const { code } = event;
        const recentlySearchedLength = recentlySearched ? recentlySearched.length - 1 : 0;
        switch (code) {
            case 'Enter':
                if (activeIndex !== -1) {
                    event.preventDefault();
                    handleSelect({ index: activeIndex, recentlySearchedItem: recentlySearched[activeIndex] });
                }
                break;
            case 'Escape':
                setActiveIndex(-1);
                setIsOpen(false);
                break;
            case 'ArrowUp':
                event.preventDefault();
                setActiveIndex(activeIndex > 0 ? activeIndex - 1 : recentlySearchedLength);
                break;
            case 'ArrowDown':
                event.preventDefault();
                setActiveIndex(activeIndex < recentlySearchedLength ? activeIndex + 1 : 0);
                break;
            default:
                break;
        }
    }, [activeIndex, handleSelect, recentlySearched, setActiveIndex, setIsOpen]);
    useEffect(() => {
        window.addEventListener('keydown', handleKeyboardEvents);
        return () => {
            window.removeEventListener('keydown', handleKeyboardEvents);
        };
    }, [handleKeyboardEvents]);
    const handleClearRecentSearches = () => {
        sendGTMEvent({ event: 'search_history_clear' });
        clearRecentSearches();
        setRecentlySearched([]);
    };
    return recentlySearched.length ? (_jsxs(StyledRecentlySearched, Object.assign({ "data-testid": "main-search-input-recently-panel" }, { children: [_jsxs(RecentlySearchedHeader, { children: [_jsx(RecentlySearchedHeaderText, { children: "Your search history" }, void 0), _jsx(Link, Object.assign({ onClick: () => handleClearRecentSearches(), role: "button", textSize: TextSizeType.TEXT14 }, { children: "Clear history" }), void 0)] }, void 0), (recentlySearched === null || recentlySearched === void 0 ? void 0 : recentlySearched.length)
                ? recentlySearched.map((recently, index) => (_jsx(AutocompleteItem, { activeSuggestionIndex: 0, "data-testid": `main-search-input-suggestion-${index}`, hasHighlight: false, iconName: IconName.HISTORY, isActive: activeIndex === index, onClick: () => handleSelect({ index, recentlySearchedItem: recently }), onMouseEnter: () => setActiveIndex(index), phrase: null, role: "link", setActiveSuggestionIndex: setActiveIndex, suggestion: recently, tabIndex: index }, `_${recently.phrase + index}`)))
                : null] }), void 0)) : null;
};
//# sourceMappingURL=RecentlySearched.js.map